import React from 'react';
import PropTypes from 'prop-types';
import {SLICE_PROP_TYPES} from '../cms-prop-types';
import {RichText} from 'prismic-reactjs';
// Creating in advance of using CSS modudles with dex
// import css from './TwoColumnTable.module.scss';

const TwoColumnTable = ({slice}) => (
    <div className="TwoColumnTable">
        <h2>{slice.primary.table_title}</h2>
        <table>
            <thead>
                <tr className="TwoColumnTable-column-titles">
                    <td>{slice.primary.left_column_title}</td>
                    <td>{slice.primary.right_column_title}</td>
                </tr>
            </thead>
            <tbody>
                {slice.items.map((row, i) => (
                    <tr key={i}>
                        <td>{RichText.render(row.left_cell_content)}</td>
                        <td>{RichText.render(row.right_cell_content)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

/* eslint-disable camelcase */
TwoColumnTable.propTypes = {
    slice: PropTypes.shape({
        ...SLICE_PROP_TYPES,
        primary: PropTypes.shape({
            table_title: PropTypes.string.isRequired,
            left_column_title: PropTypes.string.isRequired,
            right_column_title: PropTypes.string.isRequired,
        }).isRequired,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                left_cell_content: PropTypes.array.isRequired,
                right_cell_content: PropTypes.array.isRequired,
            })
        ).isRequired,
    }).isRequired,
};

export default TwoColumnTable;
